import { Fragment } from "react";

import None from "../none";
import { NEGATIVE_ZERO_PATTERN } from "./numeric-value.constants";
import "./numeric-value.scss";
import { IProps } from "./numeric-value.types";

/**
 * Display a numeric value with optional rounding.
 * @param props.options Options for formatting the number, passed to toLocaleString.
 * @param props.unit An optional unit to display after the number.
 * @param props.value The value to display.
 * @returns           Value.
 */
const NumericValue = ({ options, unit, value }: IProps) => {
    if (typeof value !== "number") {
        return <None>N/A</None>;
    }

    // Perform any necessary rounding but don't allow negative zero values like "-0".
    const formatted = options ? value.toLocaleString(undefined, options) : value.toLocaleString();
    const finalNumber = NEGATIVE_ZERO_PATTERN.test(formatted) ? formatted.replace(/^-/, "") : formatted;

    return (
        <Fragment>
            {finalNumber}
            {typeof unit !== "undefined" && <span className="numeric-value__unit">{unit}</span>}
        </Fragment>
    );
};

export default NumericValue;
